import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowSmallForwardCropped = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 13,
	viewBox: "0 0 8 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m.053 11.49 4.945-4.972L.053 1.545 1.575.018l6.478 6.5-6.478 6.5L.053 11.49z",
		clipRule: "evenodd"
	})
});
export default SvgIconArrowSmallForwardCropped;
